import React from 'react';

export default function UnCheckIconWhite({isDiabled}) {
    if(isDiabled) {
        return (
            <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect x="1" y="1" width="16" height="16" rx="4" stroke="#C7CAD1" strokeWidth="2" />
            </svg>
        );
    }
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect width="16" height="16" rx="8" fill="white" />
            <rect x="1" y="1" width="16" height="16" rx="4" stroke="#C7CAD1" strokeWidth="2" />
        </svg>
    );
}
